import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const getScenarios = (sector) =>
    api
        .get("/scenarios", { params: sector ? { sector } : {} })
        .then((r) => r.data);
export const getScenario = (slug, sector) =>
    api
        .get(`/scenarios/${slug}`, { params: sector ? { sector } : {} })
        .then((r) => r.data);
export const getSectors = () => api.get("/sectors").then((r) => r.data);
export const getKatlasStatus = () =>
    api.get("/katlas/status").then((r) => r.data);
export const createRun = (scenario_slug, facilitator_label, sector) =>
    api
        .post("/runs", { scenario_slug, facilitator_label, sector })
        .then((r) => r.data);
export const submitDecision = (run_id, payload) =>
    api.post(`/runs/${run_id}/decide`, payload).then((r) => r.data);
export const getRun = (run_id) =>
    api.get(`/runs/${run_id}`).then((r) => r.data);
export const listReceipts = () => api.get("/receipts").then((r) => r.data);
export const verifyReceipt = (run_id) =>
    api.post(`/receipts/${run_id}/verify`).then((r) => r.data);
export const getSnapshot = (token) =>
    api.get(`/snapshot/${token}`).then((r) => r.data);
export const getScenarioBriefData = (slug, sector) =>
    api
        .get(`/scenarios/${slug}`, { params: sector ? { sector } : {} })
        .then((r) => r.data);
